import Vue from 'vue'
import _ from 'lodash'
import { hamiVuex } from '@/store/base'
import { API } from '@/plugins/api'
import { projectStore } from '@/store/project'
import { promoterStore } from '@/store/promoter/promoter'

export const promoterPayoutStore = hamiVuex.store({
  $name: 'promoterPayout',
  $state: {
    payoutMap: {},
  },
  async doLoad({ promoter_customer_id, is_done, dt_created__lte, limit }) {
    let result = await API.call('merchant/promoter.query_payout', {
      project_id: projectStore.currentId,
      promoter_customer_id,
      is_done,
      dt_created__lte,
      limit,
    })
    this.$patch(state => {
      const payoutMap = {}
      result.item_s.forEach(item => {
        payoutMap[item.id] = item
      })
      state.payoutMap = payoutMap
    })
  },
  get(payoutId) {
    return this.payoutMap[payoutId]
  },
  get list() {
    return _.reverse(_.sortBy(_.values(this.payoutMap), ['dt_created']))
  },
  async doLoadPayoutPromoter(payoutIndex) {
    if (payoutIndex >= 0 && payoutIndex < this.list.length) {
      let payout = this.list[payoutIndex]
      await this._doLoadPromoterImpl(payout)
    }
    if (payoutIndex + 1 >= 0 && payoutIndex + 1 < this.list.length) {
      let payout = this.list[payoutIndex + 1]
      await this._doLoadPromoterImpl(payout)
    }
  },
  async _doLoadPromoterImpl(payout) {
    let customer_id = payout.promoter_customer_id
    let promoter = promoterStore.get(customer_id)
    if (_.isNil(promoter)) {
      promoter = await promoterStore.doGet({ customer_id })
    }
    return promoter
  },
  async doPrepare({ currency, total_should_payout__gte } = {}) {
    let result = await API.call('merchant/promoter.prepare_payout', {
      project_id: projectStore.currentId,
      currency,
      total_should_payout__gte,
    })
    return result
  },
  async doCreate({ promoter_customer_id, currency, total_should_payout__gte, dt_profit_created__lte }) {
    let result = await API.call('merchant/promoter.create_payout', {
      project_id: projectStore.currentId,
      promoter_customer_id,
      currency,
      total_should_payout__gte,
      dt_profit_created__lte,
    })
    this.$patch(state => {
      state.payoutMap[result.id] = result
    })
    return result
  },
  async doSetDone({ promoter_customer_id, payout_order_id, note }) {
    let result = await API.call('merchant/promoter.set_payout_done', {
      project_id: projectStore.currentId,
      promoter_customer_id,
      payout_order_id,
      note,
    })
    this.$patch(state => {
      state.payoutMap[result.id] = result
    })
    return result
  },
  async doDelete({ promoter_customer_id, payout_order_id }) {
    let result = await API.call('merchant/promoter.delete_payout', {
      project_id: projectStore.currentId,
      promoter_customer_id,
      payout_order_id,
    })
    this.$patch(state => {
      Vue.delete(state.payoutMap, payout_order_id)
    })
    return result
  },
})
